module.exports = __webpack_public_path__ + "static/img/mongraal.f2f61e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/mongraal.jpg
// module id = bTqb
// module chunks = 35